import { ApiEndpoints } from "../../utils/app-constants";
import { toShortDate } from "../../utils/date-utils";
import { DOCUMENT_EXTENSIONS, DOCUMENT_REQUEST_LOCATION, IDocumentRequest } from "../utilities/document-request";
import { API_METHODS } from "../utilities/type-models";

export class OrderErrorsReportDocument implements IDocumentRequest {

    public filename: string = '';
    public fileExtension: DOCUMENT_EXTENSIONS = 'xlsx';
    public openInTab: boolean = false;
    public url: string = '';
    public reportLocation: DOCUMENT_REQUEST_LOCATION = 'api';
    public methodType: API_METHODS = 'GET';

    constructor(startDate: Date) {
        var startDateStr = toShortDate(startDate);

        const searchParams = new URLSearchParams();
        searchParams.append('StartDate', startDateStr);

        var args = searchParams.toString();
        this.url = `${ApiEndpoints.PRODUCTION_ORDER_ERRORS}?${args}`;
        this.filename = `OrderErrors_${startDateStr}`;
    }

}
